import React from "react";
import "../styles/farm.css";

export default function Farm() {
  return (
    <div className="farm-experience">
      {/* HERO SECTION */}
      <section className="farm-hero">
        <div className="container">
          <span className="badge-gold">Pure Plantation Coffee</span>
          <h1>Nature Friendly <br/> Carefully Crafted Farming</h1>
          <p className="hero-lead">
            Naturally ripened. Expertly graded. Export ready. <br/>
            Sourced from the mist-shrouded elevations of the Western Ghats.
          </p>
        </div>
      </section>

      {/* THE JOURNEY SECTION */}
      <section className="farm-journey">
        <div className="container">
          
          {/* STEP 1: FINDING THE SOURCE */}
          <div className="journey-row">
            <div className="journey-img">
              <img src="https://images.unsplash.com/photo-1516746820111-665e7790b957?w=800" alt="Mountain soil" />
              <div className="img-caption">Elevation: 1200m - 1500m</div>
            </div>
            <div className="journey-text">
              <span className="step-num">01</span>
              <h2>Finding the Perfect Origin</h2>
              <p>
                Not all land is built for coffee. We scout regions with <strong>"Deep Forest Soil"</strong>—rich in volcanic nutrients and organic leaf mulch. 
                We prioritize farms at higher elevations where the temperature stays between 15°C and 25°C, ensuring the bean matures slowly for maximum sugar concentration.
              </p>
            </div>
          </div>

          {/* STEP 2: GROWING */}
          <div className="journey-row reverse">
            <div className="journey-img">
              <img src="https://images.unsplash.com/photo-1459755486867-b55449bb39ff?w=800" alt="Coffee growing" />
              <div className="img-caption">Shade-Grown Canopy</div>
            </div>
            <div className="journey-text">
              <span className="step-num">02</span>
              <h2>How We Grow: The Shade Method</h2>
              <p>
                Our coffee is <strong>"Naturally Ripened"</strong> under a two-tier canopy of Rosewood and Jackfruit trees. 
                This protects the delicate Arabica and Robusta plants from the harsh sun, creating a <strong>Nature Friendly</strong> habitat for local birds. 
                Natural ripening takes longer, but it creates a "Cheaper" cost to the environment while producing a superior, complex flavor.
              </p>
            </div>
          </div>

          {/* STEP 3: PROCESSING */}
          <div className="journey-row">
            <div className="journey-img">
              <img src="https://images.unsplash.com/photo-1527156279145-8408f61f764a?w=800" alt="Processing" />
              <div className="img-caption">Washing & Fermentation</div>
            </div>
            <div className="journey-text">
              <span className="step-num">03</span>
              <h2>Expert Grading & Processing</h2>
              <p>
                Once hand-picked, the cherries undergo a strictly monitored <strong>Washed or Natural process</strong>. 
                We use pure mountain water for pulping and then sun-dry the beans on raised "African beds." 
                Our experts then perform <strong>Precision Grading</strong> to ensure every bag is export-ready with uniform bean size and zero primary defects.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="farm-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3>100%</h3>
              <p>Traceable to Estate</p>
            </div>
            <div className="stat-card">
              <h3>0%</h3>
              <p>Chemical Ripeners</p>
            </div>
            <div className="stat-card">
              <h3>15+</h3>
              <p>Years of Soil Expertise</p>
            </div>
            <div className="stat-card">
              <h3>Nature</h3>
              <p>Friendly Practices</p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL GALLERY */}
      <section className="farm-gallery">
        <div className="container text-center">
          <h2 className="mb-5">Real Farm Snapshots</h2>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src="https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=600" alt="Red cherries" />
              <p>Cherry Ripeness Check</p>
            </div>
            <div className="gallery-item">
              <img src="https://images.unsplash.com/photo-1611854779393-1b2da9d400fe?w=600" alt="Drying" />
              <p>Traditional Drying</p>
            </div>
            <div className="gallery-item">
              <img src="https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=600" alt="Nursery" />
              <p>Young Saplings</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}